/**
 * Backend base URL. Dev uses the Vite proxy by default; production falls back
 * to the current origin so /api and /auth hit the same public host as admin.
 */
export const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (import.meta.env.PROD ? window.location.origin : "");

export const TOKEN_KEY = "uqx-admin-access";
export const REFRESH_KEY = "uqx-admin-refresh";
export const SELF_KEY = "uqx-admin-self";
